import { Flex, SearchInput } from '@lokalise/louis';
import { styled } from '@lokalise/styled';

import { spacing, typography } from '@app/theme';

export const Container = styled(Flex)`
    padding: ${spacing(5, 0)};
`;

export const Title = styled.h4`
    ${typography('heading.4')};
`;

export const SearchInputContainer = styled(SearchInput)`
    width: 385px;
`;
